import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";
import type { BuildingMetersType } from "@/types";
import { TypedDocumentNode } from "@apollo/client";
import { queries } from "@/graphql";

interface GetCompaniesBuildingsResponse {
  getBuildings: Array<BuildingMetersType | null> | null;
}

interface GetCompaniesBuildingsVariables {
  customerId?: string;
  subsidiaryId?: string;
  customerName?: string;
  subsidiaryName?: string;
  country?: string;
  zone?: string;
}

const getCompaniesBuildingsTyped =
  queries.getCompaniesBuildings as TypedDocumentNode<
    GetCompaniesBuildingsResponse,
    GetCompaniesBuildingsVariables
  >;

export function useCompanyBuildings(
  variables: GetCompaniesBuildingsVariables,
  // onCompleted: (data?: any) => void = () => {},
  // onError: (error?: any) => void = () => {},
) {
  // let variables: any;
  let skip: boolean =
    !variables.customerId &&
    !variables.customerName &&
    !variables.subsidiaryId &&
    !variables.subsidiaryName;

  // if (typeof argsOrCustomerName === "object" && argsOrCustomerName !== null) {
  //   // variables = {
  //   //   customerId: argsOrCustomerName.customerId,
  //   //   subsidiaryId: argsOrCustomerName.subsidiaryId,
  //   //   customerName: argsOrCustomerName.customerName,
  //   //   subsidiaryName: argsOrCustomerName.subsidiaryName,
  //   //   country: argsOrCustomerName.country,
  //   //   zone: argsOrCustomerName.zone ?? zone,
  //   // };
  //   // energyType = argsOrCustomerName.energyType ?? energyType;

  // } else {
  //   variables = {
  //     customerName: argsOrCustomerName || "",
  //     subsidiaryName: customerSubsidiaryString || "",
  //   };
  //   if (country) {
  //     variables.country = country;
  //   }
  //   if (zone) {
  //     variables.zone = zone;
  //   }
  //   skip = !argsOrCustomerName || !customerSubsidiaryString;
  // }

  const { data, loading, error } = useQuery(getCompaniesBuildingsTyped, {
    variables,
    skip,
  });

  const buildings = useMemo(() => {
    let returnValue: Array<BuildingMetersType> = [];
    const buildingData = data?.getBuildings;

    if (buildingData) {
      // const cleanEnergyType = (energyType?.value || energyType || null) as
      //   | EnergyBuildingKey
      //   | null;
      // if (cleanEnergyType) {
      //   returnValue = buildingData?.filter((building: BuildingMetersType) => {
      //     const energyData = building[cleanEnergyType];
      //     return energyData && energyData.length > 0;
      //   });
      // } else {
      returnValue = buildingData;
      // }
    }

    return returnValue;
    // }, [data?.getBuildings, energyType]);
  }, [data?.getBuildings]);

  // Handle success
  // useEffect(() => {
  //   if (buildings) {
  //     onCompleted(buildings);
  //   }
  // }, [buildings, onCompleted]);

  // Handle error
  // useEffect(() => {
  //   if (error) {
  //     onError(error);
  //   }
  // }, [error, onError]);

  return {
    buildings,
    loading,
    error,
  };
}
